export default __webpack_public_path__ + "static/media/juan_pelaez.9f1807e7.jpg";